import { NavigationGuard, onBeforeRouteLeave } from 'vue-router';

export const declareOnBeforeRouteLeave = (leaveGuard: NavigationGuard) => {
  onBeforeRouteLeave(leaveGuard);
};
